import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { SectionHeading } from "@/accounts-payable/common";
import type { ApVendor } from "@/accounts-payable/types";

/**
 * The vendor's ServiceTitan link. Unlinked, it says what's missing and why it
 * matters; linked, the ST name and id (there is no ServiceTitan vendor URL to
 * link to — see API.md).
 */
export const ServiceTitanSection = ({ vendor }: { vendor: ApVendor }) => (
  <Stack gap="sm" fullWidth>
    <SectionHeading>ServiceTitan</SectionHeading>
    {vendor.st_vendor_id ? (
      <Stack direction="row" gap="sm" align="baseline" className="flex-wrap">
        <Typography>{vendor.st_vendor_name}</Typography>
        <Typography textColor="tertiary">#{vendor.st_vendor_id}</Typography>
      </Stack>
    ) : (
      <Typography textColor="secondary">
        Not linked to a ServiceTitan vendor yet. Invoices can’t sync until it
        is.
      </Typography>
    )}
  </Stack>
);
